import { i18n } from "@next-core/i18n";
import { symbolAppId, symbolMenuI18nNamespace, symbolOverrideApp } from "./constants.js";
import { loadDynamicMenuItems } from "./loadDynamicMenuItems.js";
export async function mergeMenu(menuList, runtimeContext, helpers) {
  const mainMenu = menuList.find(menu => menu.type !== "inject");
  if (!mainMenu) {
    return undefined;
  }
  const validMenuList = [];
  const injectWithMenus = new Map();
  const menuWithI18n = new WeakMap();
  for (const menu of menuList) {
    if (menu.i18n) {
      const menuI18nNamespace = `menu/${menu.menuId}~${menu.app[0].appId}+${menu.instanceId}`;
      // Support any language in `menu.i18n`.
      Object.entries(menu.i18n).forEach(_ref => {
        let [lang, resources] = _ref;
        i18n.addResourceBundle(lang, menuI18nNamespace, resources);
      });
      menuWithI18n.set(menu, menuI18nNamespace);
    }
  }
  await Promise.all(menuList.map(menu => loadDynamicMenuItems(menu, runtimeContext, menuWithI18n, helpers)));
  for (const menu of menuList) {
    var _menu$items;
    if ((_menu$items = menu.items) !== null && _menu$items !== void 0 && _menu$items.length) {
      if (menu.type === "inject" && menu.injectMenuGroupId) {
        let injectingMenus = injectWithMenus.get(menu.injectMenuGroupId);
        if (!injectingMenus) {
          injectingMenus = [];
          injectWithMenus.set(menu.injectMenuGroupId, injectingMenus);
        }
        injectingMenus.push(menu);
      } else {
        validMenuList.push(menu);
      }
    }
  }
  return {
    ...mainMenu,
    items: validMenuList.flatMap(menu =>
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    processGroupInject(menu.items, menu, injectWithMenus, menuWithI18n)),
    [symbolMenuI18nNamespace]: menuWithI18n.get(mainMenu),
    [symbolOverrideApp]: mainMenu.overrideApp
  };
}
function processGroupInject(items, menu, injectWithMenus, menuWithI18n) {
  return items === null || items === void 0 ? void 0 : items.map(item => {
    var _processGroupInject;
    const foundInjectingMenus = item.groupId && injectWithMenus.get(item.groupId);
    if (foundInjectingMenus) {
      // Each menu to be injected with should be injected only once.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      injectWithMenus.delete(item.groupId);
    }
    return {
      ...item,
      children: ((_processGroupInject = processGroupInject(item.children, menu, injectWithMenus, menuWithI18n)) !== null && _processGroupInject !== void 0 ? _processGroupInject : []).concat(foundInjectingMenus ? foundInjectingMenus.flatMap(injectingMenu =>
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      processGroupInject(injectingMenu.items, injectingMenu, injectWithMenus, menuWithI18n)) : []),
      [symbolAppId]: menu.app[0].appId,
      [symbolMenuI18nNamespace]: menuWithI18n.get(menu),
      [symbolOverrideApp]: menu.overrideApp
    };
  });
}
//# sourceMappingURL=mergeMenu.js.map